import React from 'react';
import { Tabs } from 'antd';
import {
    KeywordsTab,
    CompetitorsTab,
    BrandCompetitionTab,
    MarketMatrixTab,
    RankRangeTab,
    BrandShiftTab,
} from '../index';
import { keywordColumns, competitorColumns } from '../../../config/tableColumns';

interface HotSearchTabsProps {
    keywords: any[];
    competitors: any[];
    networkData: any;
    brandDetails: any;
    networkLoading: boolean;
    brandDetailsLoading: boolean;
    matrixData: any;
    rankRangeData: any;
    brandShiftData: any;
    matrixLoading: boolean;
    onTabChange: (key: string) => void;
    onGenerateNetwork: () => void;
    onRefreshBrandDetails: () => void;
    onExportEnhanced: () => void;
}

export const HotSearchTabs: React.FC<HotSearchTabsProps> = ({
    keywords,
    competitors,
    networkData,
    brandDetails,
    networkLoading,
    brandDetailsLoading,
    matrixData,
    rankRangeData,
    brandShiftData,
    matrixLoading,
    onTabChange,
    onGenerateNetwork,
    onRefreshBrandDetails,
    onExportEnhanced,
}) => {
    return (
        <Tabs
            defaultActiveKey="keywords"
            onChange={onTabChange}
            items={[
                {
                    key: 'keywords',
                    label: `关键词指标 (${keywords.length})`,
                    children: <KeywordsTab keywords={keywords} columns={keywordColumns} />,
                },
                {
                    key: 'competitors',
                    label: `竞争对手 (${competitors.length})`,
                    children: <CompetitorsTab competitors={competitors} columns={competitorColumns} />,
                },
                {
                    key: 'brand-competition',
                    label: '品牌竞争',
                    children: (
                        <BrandCompetitionTab
                            networkData={networkData}
                            brandDetails={brandDetails}
                            loading={networkLoading}
                            brandDetailsLoading={brandDetailsLoading}
                            onGenerate={onGenerateNetwork}
                            onRefreshDetails={onRefreshBrandDetails}
                        />
                    ),
                },
                {
                    key: 'market-matrix',
                    label: '市场矩阵分类',
                    children: (
                        <MarketMatrixTab
                            matrixData={matrixData}
                            loading={matrixLoading}
                            onExport={onExportEnhanced}
                        />
                    ),
                },
                {
                    key: 'rank-range',
                    label: '搜索频率区间',
                    children: (
                        <RankRangeTab
                            rankRangeData={rankRangeData}
                            loading={matrixLoading}
                        />
                    ),
                },
                {
                    key: 'brand-shift',
                    label: '品牌市场抢占',
                    children: (
                        <BrandShiftTab
                            brandShiftData={brandShiftData}
                            loading={matrixLoading}
                        />
                    ),
                },
            ]}
        />
    );
};
